import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { url: { type: String } };

  static addressAttrs = [
    'name', 'name1', 'name2', 'zipCode', 'address', 'attnName', 'tel',
    'streetNumber', 'pOBox', 'cityName', 'country', 'destinationCountry', 'destination',
    'corporationNo', 'corporationName1', 'corporationName2', 'zipCode', 'prefecture', 'city', 'town', 'street',
    'address1', 'address2', 'address3', 'address4', 'attn', 'fax', 'taxId',
  ];

  static targets = this.addressAttrs.concat(
    'list',
    'listContainer',
    'inputMethod',
    'createButton',
    'updateButton',
    'destroyButton',
    'successMessageContainer',
    'destroyMessageContainer',
    'errorMessageContainer',
  );

  connect() {
    this.csrfToken = document.head.querySelector('[name~=csrf-token][content]')?.content;
    this.usingAttrs = [];

    this.constructor.addressAttrs.forEach((attr) => {
      if (this[`has${attr[0].toUpperCase() + attr.slice(1)}Target`]) {
        this.usingAttrs.push(attr);
      }
    });
    this.checkDisplayAddressBook();
  }

  getBody() {
    const body = { authenticity_token: this.csrfToken };
    this.usingAttrs.forEach((attr) => {
      body[attr] = this[`${attr}Target`].value;
    });

    return body;
  }

  create() {
    const url = `${this.urlValue}`;
    this.fetchAddress(url, 'POST', this.getBody());
  }

  update() {
    const id = this.listTarget.value;
    if (!id) {
      return;
    }
    const url = `${this.urlValue}/${id}`;
    this.fetchAddress(url, 'PUT', this.getBody());
  }

  destroy() {
    const id = this.listTarget.value;
    if (!id) {
      return;
    }
    const url = `${this.urlValue}/${id}`;
    const body = { authenticity_token: this.csrfToken };
    this.fetchAddress(url, 'DELETE', body);
  }

  hideMessageContainers() {
    this.errorMessageContainerTarget.classList.add('hidden');
    this.successMessageContainerTarget.classList.add('hidden');
    this.destroyMessageContainerTarget.classList.add('hidden');
  }

  fetchAddress(url, method, body) {
    this.hideMessageContainers();

    fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then((response) => {
      if (response.ok) {
        response.json().then((json) => {
          if (method === 'DELETE') {
            this.destroyMessageContainerTarget.classList.remove('hidden');
          } else {
            this.successMessageContainerTarget.classList.remove('hidden');
          }
          this.updateAddressList(json.id);
        });
      } else {
        this.errorMessageContainerTarget.classList.remove('hidden');
        const messageList = this.errorMessageContainerTarget.querySelector('.messages');
        messageList.innerHTML = '';

        response.json().then((json) => {
          json.errors.forEach((error) => {
            const li = document.createElement('li');
            li.innerHTML = error;
            messageList.appendChild(li);
          });
        });
      }
    });
  }

  handleChangeInputMethod() {
    this.checkDisplayAddressBook();
  }

  checkDisplayAddressBook() {
    const checkedInputMethod = this.inputMethodTargets.find((target) => target.checked);
    if (checkedInputMethod && checkedInputMethod.value === 'address_book') {
      this.listContainerTarget.classList.remove('hidden');
      this.createButtonTarget.classList.add('hidden');
      this.updateButtonTarget.classList.remove('hidden');
      this.destroyButtonTarget.classList.remove('hidden');
    } else if (checkedInputMethod && checkedInputMethod.value === 'new') {
      this.listContainerTarget.classList.add('hidden');
      this.createButtonTarget.classList.remove('hidden');
      this.updateButtonTarget.classList.add('hidden');
      this.destroyButtonTarget.classList.add('hidden');
    } else {
      this.listContainerTarget.classList.add('hidden');
      this.createButtonTarget.classList.add('hidden');
      this.updateButtonTarget.classList.add('hidden');
      this.destroyButtonTarget.classList.add('hidden');
    }
  }

  handleChangeAddressBookId(e) {
    this.updateAddressFields(e.currentTarget.value);
  }

  updateAddressList(value = null) {
    const url = this.urlValue;
    fetch(url, { headers: { Accept: 'text/html' } })
      .then((response) => {
        if (response.ok) {
          response.text().then((addressListHtml) => {
            this.listContainerTarget.outerHTML = addressListHtml;
            this.listTarget.value = value;
            this.checkDisplayAddressBook();
          });
        }
      });
  }

  updateAddressFields(addressBookId) {
    const url = `${this.urlValue}/${addressBookId}`;

    fetch(url).then((response) => {
      if (response.status === 200) {
        response.json().then((json) => {
          this.usingAttrs.forEach((attr) => {
            this[`${attr}Target`].value = json[attr] ? json[attr] : null;
            this[`${attr}Target`].dispatchEvent(new Event('change', { bubbles: true }));
          });
        }).catch(() => {});
      }
    });
  }
}
